// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredients__BreadBottom__16czh","BreadTop":"BurgerIngredients__BreadTop__1F9cD","Seeds1":"BurgerIngredients__Seeds1__1KqDN","Seeds2":"BurgerIngredients__Seeds2__1j0Rg","Tomato":"BurgerIngredients__Tomato__33g3H","Onion":"BurgerIngredients__Onion__10rkp","Salad":"BurgerIngredients__Salad__142r8","Cheese":"BurgerIngredients__Cheese__3JVcn","Bacon":"BurgerIngredients__Bacon__3LSem","Meat":"BurgerIngredients__Meat__1kFCF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredients/BurgerIngredients.css
// module id = 306
// module chunks = 3